export default __webpack_public_path__ + "static/media/plain-sticker-X.4ad1ad44.png";